import { ThemeOptions } from '@mui/material';
import { capitalDesignTokens } from './capital_design_tokens';

export const shape: ThemeOptions['shape'] = {
  borderRadius: capitalDesignTokens.foundations.units.unitHalf
};
